import * as React from 'react';

import {
  connectToolIcon,
  diagnosticToolIcon,
  evidenceToolIcon,
  grammarToolIcon,
  lessonsToolIcon,
  proofreaderToolIcon,
  EXTRA_SMALL_ICON_BASE_SRC,
  SMALL_ICON_BASE_SRC,
  CONNECT,
  GRAMMAR,
  DIAGNOSTIC,
  PROOFREADER,
  EVIDENCE,
  LESSONS
} from "../../Shared";

export const getIconForActivityClassification = (activityClassificationId: number) => {
  let imgAlt: string = '';
  let imgSrc: string = '';
  switch(Number(activityClassificationId)) {
    case 5:
      imgAlt = connectToolIcon.alt;
      imgSrc = connectToolIcon.src;
      break;
    case 4:
      imgAlt = diagnosticToolIcon.alt;
      imgSrc = diagnosticToolIcon.src;
      break;
    case 2:
      imgAlt = grammarToolIcon.alt;
      imgSrc = grammarToolIcon.src;
      break;
    case 6:
      imgAlt = lessonsToolIcon.alt;
      imgSrc = lessonsToolIcon.src;
      break;
    case 1:
      imgAlt = proofreaderToolIcon.alt;
      imgSrc = proofreaderToolIcon.src;
      break;
    case 9:
      imgAlt = evidenceToolIcon.alt;
      imgSrc = evidenceToolIcon.src;
      break;
    default:
      return null;
  }

  return <img alt={imgAlt} src={imgSrc} />;
}

export const getExtraSmallIconForActivityClassification = (activityClassificationId: number) => {
  let imgAlt: string = '';
  let imgSrc: string = '';
  switch(Number(activityClassificationId)) {
    case 5:
      imgAlt = connectToolIcon.alt;
      imgSrc = `${EXTRA_SMALL_ICON_BASE_SRC}/tool-connect.svg`;
      break;
    case 4:
      imgAlt = diagnosticToolIcon.alt;
      imgSrc = `${EXTRA_SMALL_ICON_BASE_SRC}/tool-diagnostic.svg`;
      break;
    case 2:
      imgAlt = grammarToolIcon.alt;
      imgSrc = `${EXTRA_SMALL_ICON_BASE_SRC}/tool-grammar.svg`;
      break;
    case 6:
      imgAlt = lessonsToolIcon.alt;
      imgSrc = `${EXTRA_SMALL_ICON_BASE_SRC}/tool-lessons.svg`;
      break;
    case 1:
      imgAlt = proofreaderToolIcon.alt;
      imgSrc = `${EXTRA_SMALL_ICON_BASE_SRC}/tool-proofreader.svg`;
      break;
    case 9:
      imgAlt = evidenceToolIcon.alt;
      imgSrc = `${EXTRA_SMALL_ICON_BASE_SRC}/tool-evidence.svg`;
      break;
    default:
      return null;
  }

  return <img alt={imgAlt} src={imgSrc} />;
}

export const getSmallIconForActivityClassification = (activityType: string) => {
  let imgAlt: string = '';
  let imgSrc: string = '';
  switch (String(activityType)) {
    case CONNECT:
      imgAlt = connectToolIcon.alt;
      imgSrc = `${SMALL_ICON_BASE_SRC}/tool-connect.svg`;
      break;
    case DIAGNOSTIC:
      imgAlt = diagnosticToolIcon.alt;
      imgSrc = `${SMALL_ICON_BASE_SRC}/tool-diagnostic.svg`;
      break;
    case GRAMMAR:
      imgAlt = grammarToolIcon.alt;
      imgSrc = `${SMALL_ICON_BASE_SRC}/tool-grammar.svg`;
      break;
    case LESSONS:
      imgAlt = lessonsToolIcon.alt;
      imgSrc = `${SMALL_ICON_BASE_SRC}/tool-lessons.svg`;
      break;
    case PROOFREADER:
      imgAlt = proofreaderToolIcon.alt;
      imgSrc = `${SMALL_ICON_BASE_SRC}/tool-proofreader.svg`;
      break;
    case EVIDENCE:
      imgAlt = evidenceToolIcon.alt;
      imgSrc = `${SMALL_ICON_BASE_SRC}/tool-evidence.svg`;
      break;
    default:
      return null;
  }

  return <img alt={imgAlt} src={imgSrc} />;
}

export const getExtraSmallColoredIconForActivityClassification = (activityClassificationId: number) => {
  let imgAlt: string = '';
  let imgSrc: string = '';
  switch(Number(activityClassificationId)) {
    case 5:
      imgAlt = connectToolIcon.alt;
      imgSrc = `${EXTRA_SMALL_ICON_BASE_SRC}/tool-connect-color.svg`;
      break;
    case 4:
      imgAlt = diagnosticToolIcon.alt;
      imgSrc = `${EXTRA_SMALL_ICON_BASE_SRC}/tool-diagnostic-color.svg`;
      break;
    case 2:
      imgAlt = grammarToolIcon.alt;
      imgSrc = `${EXTRA_SMALL_ICON_BASE_SRC}/tool-grammar-color.svg`;
      break;
    case 6:
      imgAlt = lessonsToolIcon.alt;
      imgSrc = `${EXTRA_SMALL_ICON_BASE_SRC}/tool-lessons-color.svg`;
      break;
    case 1:
      imgAlt = proofreaderToolIcon.alt;
      imgSrc = `${EXTRA_SMALL_ICON_BASE_SRC}/tool-proofreader-color.svg`;
      break;
    case 9:
      imgAlt = evidenceToolIcon.alt;
      imgSrc = `${EXTRA_SMALL_ICON_BASE_SRC}/tool-evidence-color.svg`;
      break;
    default:
      return null;
  }

  return <img alt={imgAlt} src={imgSrc} />;
}
